import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

import {
  chartReviewContainerSx,
  chartReviewHeaderSx,
  chartReviewTitleSx,
  commonBodyCellSx,
  commonHeadCellSx,
  commonTableBodyRowSx,
  commonTableHeadRowSx,
  commonTableSx
} from './Styles/ChartReviewStyles';

const chartReviewRows = [
  {
    patientName: 'Philip, Cammee John',
    description:
      'SOAP Note: Patient reports a persistent headache for the pa...',
    created: '06/09/2026'
  },
  {
    patientName: 'Alice Johnson',
    description:
      'Lab Report: Mildly elevated fasting blood glucose levels sug...',
    created: '06/09/2026'
  },
  {
    patientName: 'Philip, Cammee John',
    description:
      'SOAP Note: Patient reports a persistent headache for the pa...',
    created: '06/09/2026'
  },
  {
    patientName: 'Alice Johnson',
    description:
      'Lab Report: Mildly elevated fasting blood glucose levels sug...',
    created: '06/09/2026'
  },
  {
    patientName: 'James Hunt',
    description:
      'SOAP Note: Patient reports a persistent headache for the pa...',
    created: '06/09/2026'
  },
  {
    patientName: 'Philip, Cammee John',
    description:
      'SOAP Note: Patient reports a persistent headache for the pa...',
    created: '06/09/2026'
  },
  {
    patientName: 'Alice Johnson',
    description:
      'Lab Report: Mildly elevated fasting blood glucose levels sug...',
    created: '06/09/2026'
  },
  {
    patientName: 'Philip, Cammee John',
    description:
      'SOAP Note: Patient reports a persistent headache for the pa...',
    created: '06/09/2026'
  },
  {
    patientName: 'Alice Johnson',
    description:
      'Lab Report: Mildly elevated fasting blood glucose levels sug...',
    created: '06/09/2026'
  },
  {
    patientName: 'James Hunt',
    description:
      'SOAP Note: Patient reports a persistent headache for the pa...',
    created: '06/09/2026'
  },
  {
    patientName: 'Philip, Cammee John',
    description:
      'SOAP Note: Patient reports a persistent headache for the pa...',
    created: '06/09/2026'
  },
  {
    patientName: 'Alice Johnson',
    description:
      'Lab Report: Mildly elevated fasting blood glucose levels sug...',
    created: '06/09/2026'
  },
  {
    patientName: 'James Hunt',
    description:
      'SOAP Note: Patient reports a persistent headache for the pa...',
    created: '06/09/2026'
  },
  {
    patientName: 'Philip, Cammee John',
    description:
      'SOAP Note: Patient reports a persistent headache for the pa...',
    created: '06/09/2026'
  },
  {
    patientName: 'Alice Johnson',
    description:
      'Lab Report: Mildly elevated fasting blood glucose levels sug...',
    created: '06/09/2026'
  },
  {
    patientName: 'Philip, Cammee John',
    description:
      'SOAP Note: Patient reports a persistent headache for the pa...',
    created: '06/09/2026'
  },
  {
    patientName: 'Alice Johnson',
    description:
      'Lab Report: Mildly elevated fasting blood glucose levels sug...',
    created: '06/09/2026'
  },
  {
    patientName: 'James Hunt',
    description:
      'SOAP Note: Patient reports a persistent headache for the pa...',
    created: '06/09/2026'
  }
];

const ChartReview = ({ className }) => {
  return (
    <Box
      className={className}
      sx={{
        ...chartReviewContainerSx,
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        overflow: 'hidden'
      }}>
      <Box
        sx={{
          ...chartReviewHeaderSx,
          flexShrink: 0
        }}>
        <Typography sx={chartReviewTitleSx}>
          Recent Activity
        </Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
          position: 'relative',

          '& .scrollbar-container': {
            height: '100%'
          },

          '& .ps__rail-y': {
            display: 'none !important'
          },

          '& .ps__rail-x': {
            display: 'none !important'
          }
        }}>
        <PerfectScrollbar
          options={{
            suppressScrollX: true,
            wheelPropagation: false
          }}
          style={{
            height: '100%'
          }}>
          <Table
            stickyHeader
            sx={{
              ...commonTableSx,
              tableLayout: 'fixed',
              width: '100%'
            }}>
            <TableHead>
              <TableRow sx={commonTableHeadRowSx}>
                <TableCell
                  sx={{
                    ...commonHeadCellSx,
                    width: '35%'
                  }}>
                  Patient Name
                </TableCell>

                <TableCell
                  sx={{
                    ...commonHeadCellSx,
                    width: '43%'
                  }}>
                  Description
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    ...commonHeadCellSx,
                    width: '22%'
                  }}>
                  Created
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {chartReviewRows.map((row, index) => (
                <TableRow
                  key={`${row.patientName}-${row.created}-${index}`}
                  sx={commonTableBodyRowSx}>
                  <TableCell
                    sx={{
                      ...commonBodyCellSx,
                      fontWeight: 500,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}>
                    {row.patientName}
                  </TableCell>

                  <TableCell
                    sx={{
                      ...commonBodyCellSx,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}>
                    {row.description}
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      ...commonBodyCellSx,
                      whiteSpace: 'nowrap'
                    }}>
                    {row.created}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </PerfectScrollbar>
      </Box>
    </Box>
  );
};

ChartReview.propTypes = {
  className: PropTypes.string
};

export default withRouter(ChartReview);